import React, { HTMLAttributes, useCallback } from 'react';

import s from './LogoutButton.module.scss';
import { AppDispatch } from 'store/store';
import { useDispatch } from 'react-redux';
import { signOutOperation } from 'store/auth/auth-operations';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import useMetrics from '@hooks/useMetrics';
import { METRIC_EVENTS, METRIC_EVENTS_TRIGGERS } from '@configs/metrics/events';

interface Props extends HTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode; // текст внутри кнопки
  onClick?: () => void;
}

const LogoutButton: React.FC<Props> = ({ children, onClick, ...props }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { trackEvent } = useMetrics();
  const handleLogout = useCallback(() => {
    trackEvent(METRIC_EVENTS.logout_button, METRIC_EVENTS_TRIGGERS.main);
    /* сначала выполняем внешний onClick (закрываем сайдбар) */
    onClick?.();

    /* затем выходим из аккаунта */
    dispatch(signOutOperation());
  }, [dispatch, onClick, navigate]);

  return (
    <button
      type="button"
      onClick={handleLogout}
      className={clsx(s.logoutBtn, props.className)}
      {...props}
    >
      {children}
    </button>
  );
};

export default LogoutButton;
